import type { IFiscalQuotaRepository } from "@/application/ports/repositories/IFiscalQuotaRepository";
import { downloadBlob } from "../fileDownload";
import * as sdk from "../generated/sdk.gen";
import { unwrapBlob, unwrapBlobWithFilename } from "../unwrap";

/**
 * Repository for fiscal-quota-scoped templated document actions.
 *
 * Mirrors the contract endpoints used by ``InvestmentRepository`` for
 * financing / communication previews and downloads, but anchored on a
 * ``fiscal_quota`` (the audit document is per-quota by domain rules).
 */
export class FiscalQuotaRepository implements IFiscalQuotaRepository {
  async previewExpenseAudit(
    quotaUuid: string,
    request: { template_uuid: string },
  ): Promise<string> {
    const blob = await unwrapBlob(
      sdk.previewExpenseAudit({ path: { fiscal_quota_uuid: quotaUuid }, body: request }),
    );
    return URL.createObjectURL(blob);
  }

  async downloadExpenseAudit(quotaUuid: string, request: { template_uuid: string }): Promise<void> {
    const { blob, filename } = await unwrapBlobWithFilename(
      sdk.generateExpenseAudit({ path: { fiscal_quota_uuid: quotaUuid }, body: request }),
      `expense_audit_${quotaUuid}.pdf`,
    );
    downloadBlob(blob, filename);
  }
}
